<div id="convenios-management-view-list">
    <h2>Convenios</h2>

    <div class="three-view">
        <mat-tree [dataSource]="dataSource"  [treeControl]="treeControl">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node (click)="notifyNode(node)" (click)="activeNode = node" [ngClass]="{ 'selected': activeNode === node }" *matTreeNodeDef="let node" matTreeNodePadding>
                <!-- use a disabled button to provide padding for tree leaf -->
                <button mat-icon-button disabled class="sec-button"></button>
                {{node.nombre}}
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node  *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                    <mat-icon class="mat-icon-rtl-mirror">
                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                </button>
                {{node.name}}
            </mat-tree-node>
        </mat-tree>
    </div>

    <div class="add-new-convenios">
        <button type="button" (click)="addnewconvenios(null)"><span>+</span></button>
    </div>
</div>